import type {
  CreateNewsletterListParams,
  NewsletterList,
  UpdateNewsletterListParams,
} from "@circle-react/types/Newsletter";

import {
  reactQueryGet,
  reactQueryPost,
  reactQueryPut,
} from "../helpers/backendRequestHelpers";
import { internalApi } from "../helpers/urlHelpers";

export interface ListNewsletterListsParams {
  newsletterId: number;
  params?: {
    query?: string;
  };
}

const list = ({
  newsletterId,
  params = {},
}: ListNewsletterListsParams): Promise<NewsletterList[]> =>
  reactQueryGet<NewsletterList[]>(
    internalApi.newsletterAudienceLists.list({ newsletterId, params }),
  );

const show = ({
  newsletterId,
  id,
}: {
  id: number;
  newsletterId: number;
}): Promise<NewsletterList> =>
  reactQueryGet<NewsletterList>(
    internalApi.newsletterAudienceLists.show({ newsletterId, id }),
  );

const create = ({
  newsletterId,
  body,
}: {
  newsletterId: number;
  body: CreateNewsletterListParams;
}): Promise<NewsletterList> =>
  reactQueryPost<
    NewsletterList,
    { newsletter_list: CreateNewsletterListParams }
  >(internalApi.newsletterAudienceLists.create({ newsletterId }), {
    newsletter_list: body,
  });

const update = ({
  newsletterId,
  id,
  body,
}: {
  newsletterId: number;
  id: number;
  body: UpdateNewsletterListParams;
}): Promise<NewsletterList> =>
  reactQueryPut<
    NewsletterList,
    { newsletter_list: UpdateNewsletterListParams }
  >(internalApi.newsletterAudienceLists.update({ newsletterId, id }), {
    newsletter_list: body,
  });

export const newsletterListsApi = {
  list,
  show,
  create,
  update,
};
